module.exports = __webpack_public_path__ + "teqbahn-assets/media/what_it_looks_like.e2ff10c2.jpg";